import React, { useEffect,useState } from "react";

import TableComponent from "../../../../src/components/table/tableComponent";
import { deleteClassThunk, fetchClasses, publishClassThunk } from "../redux/classThunk";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../Popup";
import { setEditingClass, setShowForm } from "../redux/classSlice";
import ClassForm from "./createClass";
import ClassSubjectLink from "../../ClassSubjectLink"; // ✅ your modal component
import { fetchSubjects } from "../../subject/redux/subjectThunk";

export default function ViewClass() {
  const dispatch = useDispatch();
  const { classes, loading, error } = useSelector((state) => state.class);

  const showForm = useSelector((state) => state.class.showForm);
  const editingClass = useSelector((state) => state.class.editingClass);

  const [showModal, setShowModal] = useState(false);
const [selectedClassId, setSelectedClassId] = useState(null);
const [selectedClassName, setSelectedClassName] = useState(null);

const { subjects } = useSelector((state) => state.subject);

  const handleCreateNew = () => {
    dispatch(setEditingClass(null));
    dispatch(setShowForm(true));
  };

  const handleLinkSubjects = (cls) => {
  setSelectedClassId(cls.class_id);
  setSelectedClassName(cls.class_name);
  setShowModal(true);
};


  const handleEditClick = (item) => {
    dispatch(setEditingClass(item));
    dispatch(setShowForm(true));
  };

  const handleFormCancel = () => {
    dispatch(setEditingClass(null));
    dispatch(setShowForm(false));
  };

  useEffect(() => {
  dispatch(fetchClasses());
  dispatch(fetchSubjects()); // ✅ Load subjects initially
}, [dispatch]);


  useEffect(() => {
    dispatch(fetchClasses());
  }, [dispatch]);

  if (loading) {
    return <p>Loading classes...</p>;
  }

  const tableColumns = [
    { Header: "S. No", accessor: "sno" },
    { Header: "Class Name", accessor: "class_name" },
    { Header: "Actions", accessor: "actiontd" },
  ];

  const handleDeleteClick = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete class "${item.class_name}"?`
    );
    if (!confirmDelete) return;

    try {
      await dispatch(deleteClassThunk(item.class_id)).unwrap();
      dispatch(fetchClasses());
      alert("Class deleted successfully!");
      dispatch(setEditingClass(null));
    } catch (err) {
      alert(`Error deleting class: ${err}`);
    }
  };
  const handlePublishClick = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to change status  "${item.class_name}"?`
    );
    if (!confirmDelete) return;

    try {
      await dispatch(publishClassThunk(item.class_id)).unwrap();
      dispatch(fetchClasses());
      alert("Class published successfully!");
      dispatch(setEditingClass(null));
    } catch (err) {
      alert(`Error publishing class: ${err}`);
    }
  };
  const processData = (data) =>
    data.map((item, index) => ({
      ...item,
      sno: index + 1,
      actiontd: (
        <>
          <i
            className="fa fa-pencil mx-2"
            style={{ color: "green", cursor: "pointer" }}
            title="Edit"
            onClick={() => handleEditClick(item)}
          ></i>
          <i
            className="fa fa-trash mx-2"
            style={{ color: "red", cursor: "pointer" }}
            title="Delete"
            onClick={() => handleDeleteClick(item)}
          ></i>
           <i
            className={`fa mx-2 ${item.status ? "fa-toggle-on text-success" : "fa-toggle-off text-muted"}`}
            style={{ cursor: "pointer", fontSize: "20px" }}
            title={item.status ? "Click to Unpublish" : "Click to Publish"}
            onClick={() => handlePublishClick(item)}
          ></i>
          <i
            className="fa fa-link mx-2"
            title="Link Subjects"
            style={{ color: "#007bff", cursor: "pointer" }}
            onClick={() => handleLinkSubjects(item)}
          ></i>

        </>
      ),
    }));

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "relative",
        }}
      >
        <h2 style={{  textAlign: "center" }}>Class List</h2>
        <button
          style={{
            color: "#fff",
            backgroundColor: "blue",
            borderRadius: "5px",
            padding: "5px 10px",
            position: "absolute",
            right: "0",
            borderStyle: "none",
            cursor: "pointer",
          }}
          onClick={handleCreateNew}
        >
          Create Class
        </button>
      </div>

      <TableComponent
        tableColumns={tableColumns}
        tableData={processData(classes)}
      />
      {showForm && (
        <Popup
          title="Add New Class"
          onClose={handleFormCancel}
          maxWidth="600px"
          minHeight="400px"
        >
          <ClassForm />
        </Popup>
      )}
      {showModal && (
        <ClassSubjectLink
          subjects={subjects}
          selectedClassId={selectedClassId}
          selectedClassName={selectedClassName}
          onClose={() => setShowModal(false)}
        />
      )}

    </div>
  );
}
